export enum MeetingsRoutes {
  meeting = 'meeting',
  dashboard = 'dashboard',
  list = 'list',
  bookings = 'bookings',
  catering = 'catering',
  tasks = 'tasks',
  auditTrail = 'auditTrail',
  tab = 'tab',
  details = 'details',
  info = 'info',
  requests = 'requests',
  unfulfilledRequests = 'unfulfilledRequests',
  documents = 'documents',
  comments = 'comments',
    recommendations = 'recommendations',
    changeSpace = 'change-space',
  addTask='addTask',
  editTask='editTask',
  addCatering='addCatering',
  editCatering='editCatering',
  edit='edit',
  addDocuments = 'add-documents',
  copyBooking='copy'
}
